import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { map, filter, distinctUntilChanged } from 'rxjs';
import { State } from '@feature/widget-columns/reducers/widget-columns.reducer';
import * as widgetColumnSelectors from '@feature/widget-columns/selectors/widget-columns.selectors';

@Injectable({
  providedIn: 'root'
})
export class WidgetColumnsFacadeService {

  constructor(
    private readonly store: Store<State>
  ) { }

  availableColumns(widgetId: number) {
    return this.store.select(widgetColumnSelectors.availableColumns(widgetId));
  }

  loaded(widgetId: number) {
    return this.store.select(widgetColumnSelectors.isLoading(widgetId)).pipe(distinctUntilChanged(), filter(l => !l ),map(l => !l));
  }


}
